var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcSidebarOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.41,
    height: 12,
    viewBox: "0 0 20.41 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_301",
    "data-name": "Group 301",
    transform: "translate(-159.783 -34.538)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_menu_24px",
    d: "M3,18H13V16H3Zm0-5H13V11H3ZM3,6V8H13V6Z",
    transform: "translate(167.193 28.538)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_chevron_left_24px",
    d: "M15.41,7.41,14,6,8,12l6,6,1.41-1.41L10.83,12Z",
    transform: "translate(151.783 28.538)",
    fill: "#ccc"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSidebarOpen);
export default __webpack_public_path__ + "static/media/ic_sidebar_open.4a7d029f33322a40a40614c1b746e538.svg";
export { ForwardRef as ReactComponent };